import cookie from 'react-cookies';
import axios from 'axios';
import { firebaseAppAuth, instanceBackend, instanceQrcode, instanceReporting } from '@/App';
import { signOut } from 'firebase/auth';
import { store } from "@/index";
import { sessionGet } from '@/redux/_session.actions';
import { Session } from '@/redux/_session.types';

//Déconnexion de l'application
//Supprimer cookies et informations utilisateur
//Redirection vers login
const logout = async (expired: boolean) => {
  const internal = store.getState()._session.interfaceType === "SUPERVISOR" || store.getState()._session.connectedAsSupervisor
  const requests: Promise<unknown>[] = [signOut(firebaseAppAuth)]
  const refreshToken = cookie.load('idtreeRefreshToken')
  if (refreshToken && refreshToken !== 'null') {
    requests.push(instanceBackend.post('/_auth/logout', { refreshToken }, { timeout: 10000 }))
  }
  await Promise.allSettled(requests)
  for (const instance of [instanceBackend, instanceQrcode, instanceReporting]) {
    delete instance.defaults.headers.common['firebaseToken']
    delete instance.defaults.headers.common['idtreeToken']
    delete instance.defaults.headers.common['reportingToken']
  }
  cookie.remove('reportingToken', { path: '/' })
  cookie.remove('firebaseToken', { path: '/' })
  cookie.remove('idtreeToken', { path: '/' })
  cookie.remove('idtreeRefreshToken', { path: '/' })
  cookie.remove('idtreeEstablishmentId', { path: '/' })
  axios.defaults.headers.common['firebaseToken'] = null
  axios.defaults.headers.common['idtreeToken'] = null
  store.dispatch(sessionGet(new Session()))
  window.location.href = window.location.origin + (internal ? '/login/supervisor' : '/login/app') + (expired ? "?message=session_expired" : "")
}

export default logout;
